import { existValueAndEmptyString } from "./util";

export function formatToMoney(num, minimumFractionDigits = 2, symbol) {
  return formatCurrencyAndTwoDecimalsString(
    convertBathToStangAndRoundTwoDecimal(num), minimumFractionDigits, symbol
  );
}

export function formatNumber(num, minimumFractionDigits = 0) {
  return num.toLocaleString(undefined, { minimumFractionDigits });
}

export function convertPriceStringToInt(item) {
  const price = item && item >= 0
    ? parseInt((parseFloat(item) * 100).toFixed(2))
    : null

  return price
}

export function convertBathToStangAndRoundTwoDecimal(num) {
  const floatItem = num !== null && num >= 0
    ? +(Math.round((+num / 100) + "e+2")  + "e-2")
    : undefined

  return floatItem
}

export function convertStangToBathAndRoundTwoDecimal(num) {
  const multiplyMoney = num !== null && parseFloat(num) >= 0
  ? roundToTwoAndMultiplyOneHundred(num)
  : undefined;

  return parseInt(multiplyMoney);
}

export function roundToTwoAndMultiplyOneHundred(num) {
  return +(Math.round((num * 100) + "e+2")  + "e-2");
}

export function formatDecimal(num, decimalDigits = 2) {
  const floatItem = num >= 0
    ? parseFloat(num.toFixed(decimalDigits))
    : undefined

  return floatItem
}

export function formatCurrencyAndTwoDecimalsString(
  number,
  minimumFractionDigits = 2,
  symbol
) {
  return number
    ? `${symbol || ""}${formatNumber(number, minimumFractionDigits)}`
    : number;
}

export function convertPriceStringToNumber(priceString) {
  return priceString
    ? parseFloat(priceString.replace(/,/g, ''))
    : null;
}

export function formatCurrencyBath(priceString) {
  return existValueAndEmptyString(priceString)
    ? formatCurrencyAndTwoDecimalsString(priceString, 2, "฿")
    : null;
}

export function decimalToBaht(number, decimalDigits = 2) {
  // Validate not null or undefined
  if (!number) return number;

  // NOTE: if number is string convert to number
  if (typeof number !== "number" && number !== null) {
    number = Number(number)
  }

  // NOTE: convert decimal to baht
  const baht = parseFloat(number * 0.01)

  // NOTE: if decimalDigits is 0 return floor baht
  if (decimalDigits === 0) {
    return Math.floor(baht);
  } else {
    return baht.toFixed(decimalDigits);
  }
}

export function formatCurrencyStang(number) {
  // Validate not null or undefined
  if (!number) return number;

  // NOTE: if number is string convert to number
  if (typeof number !== "number" && number !== null) {
    number = Number(number)
  }

  // NOTE: convert to currency format with 2 decimal
  return number.toLocaleString(undefined, { minimumFractionDigits: 2 })
}


// WEBPACK FOOTER //
// ./src/lib/formatter.js